import { Navigate, useLocation } from "react-router-dom";
import { SETTINGS_SECTIONS } from "../../app/terminology/settings";

/** App settings tab pages. */
export const SETTINGS_PATHS = {
    searchResults: "/settings/search-results",
    selectorFields: "/settings/selector-fields",
    storefrontText: "/settings/storefront-text",
    appearance: "/settings/appearance",
    data: "/settings/data",
    integrations: "/settings/integrations",
    advanced: "/settings/advanced",
} as const;

export const SETTINGS_TABS = [
    { label: SETTINGS_SECTIONS.searchResults, path: SETTINGS_PATHS.searchResults },
    { label: SETTINGS_SECTIONS.selectorFields, path: SETTINGS_PATHS.selectorFields },
    { label: SETTINGS_SECTIONS.storefrontText, path: SETTINGS_PATHS.storefrontText },
    { label: SETTINGS_SECTIONS.appearance, path: SETTINGS_PATHS.appearance },
    { label: "Data", path: SETTINGS_PATHS.data },
    { label: SETTINGS_SECTIONS.vendorIntegrations, path: SETTINGS_PATHS.integrations },
    { label: SETTINGS_SECTIONS.advanced, path: SETTINGS_PATHS.advanced },
] as const;

// Phase 1: these tabs configure the native storefront, which Legacy stores don't
// use yet. Their selector fields and labels come from the migrated PFV1 settings.
export const LEGACY_HIDDEN_SETTINGS_PATHS: readonly string[] = [
    SETTINGS_PATHS.selectorFields,
    SETTINGS_PATHS.storefrontText,
    SETTINGS_PATHS.appearance,
    SETTINGS_PATHS.integrations,
];

export const getSettingsTabs = (isLegacy: boolean) => isLegacy
    ? SETTINGS_TABS.filter(tab => !LEGACY_HIDDEN_SETTINGS_PATHS.includes(tab.path))
    : SETTINGS_TABS;

// Section keys of the retired settings editor, still used by links and bookmarks.
const legacySections: Record<string, string> = {
    "search-results": SETTINGS_PATHS.searchResults,
    "selector-fields": SETTINGS_PATHS.selectorFields,
    "storefront-text": SETTINGS_PATHS.storefrontText,
    "preview-test": SETTINGS_PATHS.appearance,
    appearance: SETTINGS_PATHS.appearance,
    "reference-data": SETTINGS_PATHS.data,
    attributes: SETTINGS_PATHS.data,
    "data-refresh": SETTINGS_PATHS.data,
    integrations: SETTINGS_PATHS.integrations,
    advanced: SETTINGS_PATHS.advanced,
    plan: "/plan",
};

/** Where an old `?section=` link points now, keeping its other query values. */
export function settingsSectionTarget(search: string, hash = "") {
    const params = new URLSearchParams(search);
    const section = params.get("section");
    params.delete("section");
    const rest = params.toString();
    return {
        pathname: (section && legacySections[section]) || SETTINGS_PATHS.searchResults,
        search: rest ? `?${rest}` : "",
        hash,
    };
}

/** Sends `/storefront?section=…` and `/settings?section=…` links to their settings tab. */
export function SettingsSectionRedirect() {
    const location = useLocation();
    return <Navigate replace to={settingsSectionTarget(location.search, location.hash)} />;
}
